import React from "react";

import Version from "../components/Version";

import TopbarLanguage from "../containers/Topbar/TopbarLanguage";
import LegalStuff from "../components/LegalStuff";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import emz from "../image/emz.svg";

// Bottom bar styles
const bottomBarClasses = `
  w-full absolute bottom-0 left-0 flex flex-row justify-center items-center
  max-[992px]:relative max-[992px]:mt-[100px]
  [&_.ant-btn-link_span]:text-sm [&_.ant-btn-link_span]:font-light [&_.ant-btn-link_span]:leading-[19px]
  [&_.ant-btn-link_span]:text-center [&_.ant-btn-link_span]:text-[#03af5c]
  [&_.bottom-bar-content]:w-[min(750px,90%)] [&_.bottom-bar-content]:h-[100px]
  [&_.bottom-bar-content]:flex [&_.bottom-bar-content]:flex-wrap [&_.bottom-bar-content]:flex-row
  [&_.bottom-bar-content]:justify-center [&_.bottom-bar-content]:items-center
  [&_.bottom-bar-content_.app-version]:w-20 [&_.bottom-bar-content_.app-version]:text-right
  [&_.bottom-bar-content_.legal-wrapper]:flex [&_.bottom-bar-content_.legal-wrapper]:justify-center
  [&_.bottom-bar-content_.language-button]:rounded-[10px]
  [&_.bottom-bar-content_.language-button_svg]:!text-[var(--primary)]
  [&_.ant-btn-link]:!p-0 [&_.ant-btn-link]:!ml-[30px]
  [&_.ant-dropdown-trigger]:ml-[30px]
`;

// Mobile bottom bar styles
const bottomBarMobileClasses = `
  flex-col justify-normal
  [&_.bottom-bar-content]:flex-col [&_.bottom-bar-content]:justify-normal
  [&_.version-language-wrapper]:w-full [&_.version-language-wrapper]:flex-[10]
  [&_.version-language-wrapper]:flex [&_.version-language-wrapper]:justify-between [&_.version-language-wrapper]:flex-row
  [&_.legal-stuff-wrapper]:w-full [&_.legal-stuff-wrapper]:flex [&_.legal-stuff-wrapper]:justify-between
  [&_.legal-stuff-wrapper]:flex-row [&_.legal-stuff-wrapper]:flex-[10] [&_.legal-stuff-wrapper]:items-center
  [&_.ant-btn-link]:p-0 [&_.ant-btn-link]:ml-0
  [&_.ant-dropdown-trigger]:ml-0
`;

export default function () {
  const { sm } = useBreakpoint();
  if (!sm) {
    return (
      <div className={`bottom-bar bottom-bar-mobile ${bottomBarClasses} ${bottomBarMobileClasses}`}>
        <div className={"bottom-bar-content"}>
          <div className={"version-language-wrapper"}>
            <Version />
            <TopbarLanguage />
          </div>
          <div className={"legal-stuff-wrapper"}>
            <LegalStuff noWrapper />
            <img alt={"company logo"} src={emz} width={60} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`bottom-bar ${bottomBarClasses}`}>
      <div className={"bottom-bar-content"}>
        <img alt={"company logo"} className={"mr-2"} src={emz} width={70} />
        <Version />
        <LegalStuff noWrapper />
        <TopbarLanguage />
      </div>
    </div>
  );
}
